import { merge, Observable } from 'rxjs';
import { ComponentOutputStatus } from '../normalizzazione/component-output-status';
import { Tuple } from '../models/tuple';
import { map, scan, startWith, delay, tap } from 'rxjs/operators';

// @dynamic
export class ComponentReducer {

  public static reducer2<T>(
    m1: Observable<ComponentOutputStatus<(value: T) => void>>,
    m2: Observable<ComponentOutputStatus<(value: T) => void>>,
    isComplete: (value: T) => boolean,
    startValue: ComponentOutputStatus<T>): Observable<ComponentOutputStatus<T>> {
    const cardinality = 2;
    const merged: Observable<Tuple<number, ComponentOutputStatus<(value: T) => void>>> = merge(
      ComponentReducer.ordinal(m1, 1),
      ComponentReducer.ordinal(m2, 2),
    )
    return ComponentReducer.reducerInternal(merged, startValue, cardinality, isComplete);
  }

  public static reducer3<T>(
    m1: Observable<ComponentOutputStatus<(value: T) => void>>,
    m2: Observable<ComponentOutputStatus<(value: T) => void>>,
    m3: Observable<ComponentOutputStatus<(value: T) => void>>,
    isComplete: (value: T) => boolean,
    startValue: ComponentOutputStatus<T>): Observable<ComponentOutputStatus<T>> {
    const cardinality = 3;
    const merged: Observable<Tuple<number, ComponentOutputStatus<(value: T) => void>>> = merge(
      ComponentReducer.ordinal(m1, 1),
      ComponentReducer.ordinal(m2, 2),
      ComponentReducer.ordinal(m3, 3)
    )
    return ComponentReducer.reducerInternal(merged, startValue, cardinality, isComplete);
  }

  public static reducer4<T>(
    m1: Observable<ComponentOutputStatus<(value: T) => void>>,
    m2: Observable<ComponentOutputStatus<(value: T) => void>>,
    m3: Observable<ComponentOutputStatus<(value: T) => void>>,
    m4: Observable<ComponentOutputStatus<(value: T) => void>>,
    isComplete: (value: T) => boolean,
    startValue: ComponentOutputStatus<T>): Observable<ComponentOutputStatus<T>> {
    const cardinality = 4;
    //TODO
    // m3.subscribe(_ => console.log("m3", _))
    const merged: Observable<Tuple<number, ComponentOutputStatus<(value: T) => void>>> = merge(
      ComponentReducer.ordinal(m1, 1),
      ComponentReducer.ordinal(m2, 2),
      ComponentReducer.ordinal(m3, 3),
      ComponentReducer.ordinal(m4, 4)
    )
    // merged.subscribe(_ => console.log("merged", _));
    return ComponentReducer.reducerInternal(merged, startValue, cardinality, isComplete);
  }

  public static reducer5<T>(
    m1: Observable<ComponentOutputStatus<(value: T) => void>>,
    m2: Observable<ComponentOutputStatus<(value: T) => void>>,
    m3: Observable<ComponentOutputStatus<(value: T) => void>>,
    m4: Observable<ComponentOutputStatus<(value: T) => void>>,
    m5: Observable<ComponentOutputStatus<(value: T) => void>>,
    isComplete: (value: T) => boolean,
    startValue: ComponentOutputStatus<T>): Observable<ComponentOutputStatus<T>> {
    const cardinality = 5;
    const merged: Observable<Tuple<number, ComponentOutputStatus<(value: T) => void>>> = merge(
      ComponentReducer.ordinal(m1, 1),
      ComponentReducer.ordinal(m2, 2),
      ComponentReducer.ordinal(m3, 3),
      ComponentReducer.ordinal(m4, 4),
      ComponentReducer.ordinal(m5, 5)
    )
    return ComponentReducer.reducerInternal(merged, startValue, cardinality, isComplete);
  }

  public static reducer6<T>(
    m1: Observable<ComponentOutputStatus<(value: T) => void>>,
    m2: Observable<ComponentOutputStatus<(value: T) => void>>,
    m3: Observable<ComponentOutputStatus<(value: T) => void>>,
    m4: Observable<ComponentOutputStatus<(value: T) => void>>,
    m5: Observable<ComponentOutputStatus<(value: T) => void>>,
    m6: Observable<ComponentOutputStatus<(value: T) => void>>,
    isComplete: (value: T) => boolean,
    startValue: ComponentOutputStatus<T>): Observable<ComponentOutputStatus<T>> {
    const cardinality = 6;
    const merged: Observable<Tuple<number, ComponentOutputStatus<(value: T) => void>>> = merge(
      ComponentReducer.ordinal(m1, 1),
      ComponentReducer.ordinal(m2, 2),
      ComponentReducer.ordinal(m3, 3),
      ComponentReducer.ordinal(m4, 4),
      ComponentReducer.ordinal(m5, 5),
      ComponentReducer.ordinal(m6, 6)
    )
    return ComponentReducer.reducerInternal(merged, startValue, cardinality, isComplete);
  }

  public static reducer7<T>(
    m1: Observable<ComponentOutputStatus<(value: T) => void>>,
    m2: Observable<ComponentOutputStatus<(value: T) => void>>,
    m3: Observable<ComponentOutputStatus<(value: T) => void>>,
    m4: Observable<ComponentOutputStatus<(value: T) => void>>,
    m5: Observable<ComponentOutputStatus<(value: T) => void>>,
    m6: Observable<ComponentOutputStatus<(value: T) => void>>,
    m7: Observable<ComponentOutputStatus<(value: T) => void>>,
    isComplete: (value: T) => boolean,
    startValue: ComponentOutputStatus<T>): Observable<ComponentOutputStatus<T>> {
    const cardinality = 7;
    const merged: Observable<Tuple<number, ComponentOutputStatus<(value: T) => void>>> = merge(
      ComponentReducer.ordinal(m1, 1),
      ComponentReducer.ordinal(m2, 2),
      ComponentReducer.ordinal(m3, 3),
      ComponentReducer.ordinal(m4, 4),
      ComponentReducer.ordinal(m5, 5),
      ComponentReducer.ordinal(m6, 6),
      ComponentReducer.ordinal(m7, 7)
    )
    return ComponentReducer.reducerInternal(merged, startValue, cardinality, isComplete);
  }

  public static reducer8<T>(
    m1: Observable<ComponentOutputStatus<(value: T) => void>>,
    m2: Observable<ComponentOutputStatus<(value: T) => void>>,
    m3: Observable<ComponentOutputStatus<(value: T) => void>>,
    m4: Observable<ComponentOutputStatus<(value: T) => void>>,
    m5: Observable<ComponentOutputStatus<(value: T) => void>>,
    m6: Observable<ComponentOutputStatus<(value: T) => void>>,
    m7: Observable<ComponentOutputStatus<(value: T) => void>>,
    m8: Observable<ComponentOutputStatus<(value: T) => void>>,
    isComplete: (value: T) => boolean,
    startValue: ComponentOutputStatus<T>): Observable<ComponentOutputStatus<T>> {
    const cardinality = 8;
    const merged: Observable<Tuple<number, ComponentOutputStatus<(value: T) => void>>> = merge(
      ComponentReducer.ordinal(m1, 1),
      ComponentReducer.ordinal(m2, 2),
      ComponentReducer.ordinal(m3, 3),
      ComponentReducer.ordinal(m4, 4),
      ComponentReducer.ordinal(m5, 5),
      ComponentReducer.ordinal(m6, 6),
      ComponentReducer.ordinal(m7, 7),
      ComponentReducer.ordinal(m8, 8)
    )
    return ComponentReducer.reducerInternal(merged, startValue, cardinality, isComplete);
  }

  public static reducer9<T>(
    m1: Observable<ComponentOutputStatus<(value: T) => void>>,
    m2: Observable<ComponentOutputStatus<(value: T) => void>>,
    m3: Observable<ComponentOutputStatus<(value: T) => void>>,
    m4: Observable<ComponentOutputStatus<(value: T) => void>>,
    m5: Observable<ComponentOutputStatus<(value: T) => void>>,
    m6: Observable<ComponentOutputStatus<(value: T) => void>>,
    m7: Observable<ComponentOutputStatus<(value: T) => void>>,
    m8: Observable<ComponentOutputStatus<(value: T) => void>>,
    m9: Observable<ComponentOutputStatus<(value: T) => void>>,
    isComplete: (value: T) => boolean,
    startValue: ComponentOutputStatus<T>): Observable<ComponentOutputStatus<T>> {
    const cardinality = 9;
    const merged: Observable<Tuple<number, ComponentOutputStatus<(value: T) => void>>> = merge(
      ComponentReducer.ordinal(m1, 1),
      ComponentReducer.ordinal(m2, 2),
      ComponentReducer.ordinal(m3, 3),
      ComponentReducer.ordinal(m4, 4),
      ComponentReducer.ordinal(m5, 5),
      ComponentReducer.ordinal(m6, 6),
      ComponentReducer.ordinal(m7, 7),
      ComponentReducer.ordinal(m8, 8),
      ComponentReducer.ordinal(m9, 9)
    )
    return ComponentReducer.reducerInternal(merged, startValue, cardinality, isComplete);
  }

  private static reducerInternal<T>(
    mergedMutators: Observable<Tuple<number, ComponentOutputStatus<(value: T) => void>>>,
    startValue: ComponentOutputStatus<T>,
    cardinality: number,
    isComplete: (value: T) => boolean):
    Observable<ComponentOutputStatus<T>> {

    const accumulatorAndValidity: Tuple<Array<boolean>, ComponentOutputStatus<T>> =
      Tuple.of([], startValue); // startValue è un valore normalizzato
    return mergedMutators.pipe(
      //TODO
      // tap(_ => console.log("mergedMutators", _)),
      scan((
        accumulator: Tuple<Array<boolean>, ComponentOutputStatus<T>>,
        mutator: Tuple<number, ComponentOutputStatus<(value: T) => void>>
      ) => {
        accumulator._2.mapValue(mutator._2.output);
        accumulator._1[mutator._1] = mutator._2.status;
        //TODO
        // console.log("muttator", accumulator._2.mapValue(mutator._2.output));
        // console.log("accumulator", accumulator);
        return accumulator;
      },
        accumulatorAndValidity //valore iniziale
      ),
      map((accumulator: Tuple<Array<boolean>, ComponentOutputStatus<T>>) => {

        const validities: Array<boolean> = accumulator._1;
        const isValid: boolean =
          isComplete(accumulator._2.output) &&
          validities.reduce((acc, x) => acc && (x == null || x), true);

        return ComponentOutputStatus.of(isValid, accumulator._2.output);
      }),
      delay(0),
      startWith(startValue)
    );
  }

  private static ordinal<T>(
    mutator: Observable<ComponentOutputStatus<(value: T) => void>>, order: number):
    Observable<Tuple<number, ComponentOutputStatus<(value: T) => void>>> {
    return mutator.pipe(
      map(x => Tuple.of(order, x))
    );
  }
}
